module.exports = __webpack_public_path__ + "static/media/partnership.ddd7051a.svg";